const routes = [
  {
    path: "/marketing/campaign_gallery",
    name: "campaign_gallery",
    component:  () => import(/* webpackChunkName: "CampaignsGallery" */ "./views/CampaignsGallery"),
    children: [
      {
        path: "*",
        redirect: { name: "campaign_gallery"}
      }
    ]
  },
  {
    path: "/marketing/campaign_preview",
    name: "campaign_preview",
    component:  () => import(/* webpackChunkName: "CampaignPreview" */ "./views/CampaignPreview"),
    props: route => ({
      isNewGallery: route.query.isNewGallery === "true",
      type: route.query.type,
    }),
    children: [
      {
        path: "*",
        redirect: { name: "campaign_gallery"}
      }
    ]
  },
  {
    path: "/marketing/new_campaign_gallery",
    name: "new_campaign_gallery",
    component:  () => import(/* webpackChunkName: "NewCampaignGallery" */ "./views/NewCampaignGallery"),
    props: route => ({
      tab: route.query.tab,
      isAutoCampaign: route.query.isAutoCampaign === "true"
    }),
    children: [
      {
        path: "*",
        redirect: { name: "new_campaign_gallery"}
      }
    ]
  },
  {
    path: "/marketing/campaign_template_preview",
    name: "campaign_template_preview",
    component: () => import(/* webpackChunkName: "CampaignTemplatePreviewDialog" */ "./views/CampaignTemplatePreviewDialog")
  },
  {
    path: "/marketing/pro_campaign",
    name: "new_pro_campaign",
    component: () => import(/* webpackChunkName: "ProCampaignEditor" */ "./views/ProCampaignEditor"),
    props: route => ({
      templateUid: route.query.template,
      isAutoCampaign: route.query.isAutoCampaign === 'true'
    })
  },
  {
    path: "/marketing/pro_campaign/:uid",
    name: "edit_pro_campaign",
    component: () => import(/* webpackChunkName: "ProCampaignEditor" */ "./views/ProCampaignEditor"),
    props: route => ({
      campaignUid: route.params.uid,
      isAutoCampaign: route.query.isAutoCampaign === 'true'
    })
  },
  {
    path: "/marketing/campaign_trigger_dialog",
    name: "campaign_trigger_dialog",
    component: () => import(/* webpackChunkName: "CampaignTriggerDialog" */ "./views/CampaignTriggerDialog"),
    props: route => ({
      editMode: route.query.edit === 'true',
      campaignUid: route.query.campaignUid !== 'undefined' ? route.query.campaignUid : null
    })
  },
  {
    path: '/activate_campaign_dialog/:uid',
    name: 'ActivateCampaignDialogPage',
    component: () => import(/* webpackChunkName: "ActivateCampaignDialogPage" */ "@/modules/marketing/views/ActivateCampaignDialogPage"),
    props: route => ({
      campaignUid: route.params.uid,
      isPro: route.query.pro === 'true'
    })
  }
];

export default routes;
